// @ts-nocheck
'use strict';
import $ from 'jquery';
import { getCookie } from '../base/utils/get_cookie.js';






function setUpUI(){

  console.log('setUpUI')
  $("#submit_question").on('click', function() {
    grecaptcha.execute("6LeyDqsqAAAAAJKNcs4NGJg8tYQmn6bAFrdK65dN").then(function(token) {


      let email = $("#i_email").val().trim()
    let tel = $("#i_tel").val().trim()
    let name = $("#i_name").val().trim()
    let question = $("#i_question").val().trim()
    if(email == "" && tel == ""){
      alert("이메일이나 연락처 중 하나는 입력하셔야 합니다.")
      return;
    }

    const url = '/intro/submin_question/';
    let data = {}
    data.email = email
    data.tel = tel
    data.name = name
    data.recaptcha_token = token
    data.question = question
    console.log(data)
    fetch(url, {
      method: 'post',
      body: JSON.stringify(data),
      mode: 'same-origin', // no-cors, *cors, same-origin
      headers: { 'X-CSRFToken': getCookie('csrftoken'), },
      credentials: 'include',
    }).then((res) => {

      
      if (res.status === 200 || res.status === 201) {
        res.json().then((json_res) => {
          console.log(json_res)
          if(json_res.msg == 'ok'){
            alert('성공적으로 전송되었습니다.');
            window.location.href='/'
        }
        else{
          alert('보안 이유로 전송 실패하였습니다.');
        }   
        });
      } else {
        alert('전송시 오류 발생.');
      }
    });


    });
   
  }

);

}

setUpUI();
